import { render, staticRenderFns } from "./ProcessDiagram.vue?vue&type=template&id=3351570a"
import script from "./ProcessDiagram.vue?vue&type=script&lang=js"
export * from "./ProcessDiagram.vue?vue&type=script&lang=js"
import style0 from "./ProcessDiagram.vue?vue&type=style&index=0&id=3351570a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports